export * from "./ManagementPrimSpecCard";
